// Components
import Ring from "./Ring/Ring";

type GraphRingsType = {
  size: number;
  tickNum: number;
  ariaLabel: string;
};

const GraphRings = ({ size, tickNum, ariaLabel }: GraphRingsType) => {
  const ringBaseDimension = size / tickNum;
  const baseMargin = size / 2;

  return (
    <>
      {Array.from({ length: tickNum }).map((_, i) => {
        const factor = tickNum - i;
        const computedMargin = baseMargin - (baseMargin / tickNum) * factor;
        const dimension = ringBaseDimension * factor;

        return (
          <div
            key={i}
            style={{
              position: "absolute",
              marginTop: computedMargin,
              marginLeft: computedMargin,
            }}
            aria-label={ariaLabel}
          >
            <Ring height={dimension} width={dimension} />
          </div>
        );
      })}
    </>
  );
};

export default GraphRings;
